import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { CycleService } from '../../../../../core/services/cycle.service';
import { LevelService } from '../../../../../core/services/level.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
    selector: 'app-classroom',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule,],
    templateUrl: './classroom.component.html',
    styleUrls: ['./classroom.component.css']
})
export class ClassroomComponent {
  buttonsPermission :any|undefined;
  search_text=""
  levelsFiltered:any[] =[]
  levels:any[] =[]
  cycles:any[] =[]
  data:any[] =[]
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  cycleId:any
  loading=false
  tag="admin-classrooms"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any


  constructor(
    private classroomService:ClassroomService,
    private cycleService:CycleService,
    private levelService:LevelService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.user=this.lsService.get(GlobalName.userName)
    this.init()
    this.getActions()
  }

  init(){
    this.getAll()
    this.getLevels()
    this.getCycles()
  
  }


  getCycles(){
    this.cycleService.getByState(1,'recup').subscribe((res:any)=>{
      this.cycles=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des classes",err)
    })
  }
  getLevels(){
    this.levelService.getByState(1,'recup').subscribe((res:any)=>{
      this.levels=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des classes",err)
    })
  }
  loadLevels(event:any){
    this.levelsFiltered= this.levels.filter((el:any)=>el.cycle_id == event?.target.value)
  }

  getAll(){
    this.classroomService.getAll().subscribe((res:any)=>{
      this.data=res.data
      this.pg.pageSize=10
      this.pg.p=0
      this.pg.total=res.data.length
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des classes",err)
    })
  }


  store(value:any){
    this.loading=true
    
    this.classroomService.store(value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des classes",err)

    })
  }
  update(value:any){
    this.loading=true

    this.classroomService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des classes",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.classroomService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des classes",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
    this.cycleId=this.levels.find((el:any)=>el.id == this.selected_data.level_id)?.cycle_id
    this.levelsFiltered= this.levels.filter((el:any)=>el.cycle_id == this.cycleId)

  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.classroomService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des classes",err)

      })
  }

  getPage(event:any){
    this.pg.p=event
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }
}
